<template lang="pug">
  b-container(fluid)
    b-row.p-3
      h2 Results Testing

    b-row
      b-col
        b-form-group(label-cols="4" label="Type" label-align="left")
          b-form-select(v-model="case_tech_type" :options="type_options").mb-3
        b-form-group(label-cols="4" label="Sub-type" label-align="left")
          b-form-select(v-model="case_tech_subtype" :options="subType_options").mb-3

    b-row
      b-col(cols=3)
        b-row.p-3
          b-form-group(label-cols="4" label="Inflow:" label-align="left")
            b-input-group(append="m3/day")
              b-form-input(id="inflow" name="inflow" type="number" v-model.trim="inflow" )
        b-row
          b-col Select
          b-col
            b-form-group()
              b-form-select().mb-3
          b-col
            b-form-group()
              b-form-select().mb-3
        b-row
          b-col(cols="2")
          b-col.text-center Input
          b-col Output
        b-row
          b-col
            b-form-group(label-cols="2" :label="'BOD'" label-align="left")
              b-input-group(:append="'mg/L'")
                b-form-input(:id="'bod'+'_in'" :name="'bod'+'_in'" type='number' v-model="inputs.bod_in")
                b-form-input(:id="'bod'+'_out'" :name="'bod'+'_out'" type='number' v-model="inputs.bod_out")
        b-row
          b-col
            b-form-group(label-cols="2" :label="'COD'" label-align="left")
              b-input-group(:append="'mg/L'")
                b-form-input(:id="'cod'+'_in'" :name="'cod'+'_in'" type='number' v-model="inputs.cod_in")
                b-form-input(:id="'cod'+'_out'" :name="'cod'+'_out'" type='number' v-model="inputs.cod_out")
        b-row
          b-col
            b-form-group(label-cols="2" :label="'TN'" label-align="left")
              b-input-group(:append="'mg/L'")
                b-form-input(:id="'tn'+'_in'" :name="'tn'+'_in'" type='number' v-model="inputs.tn_in")
                b-form-input(:id="'tn'+'_out'" :name="'tn'+'_out'" type='number' v-model="inputs.tn_out")

        //InputInOut(label="BOD", id_custom="bod", type="number" , description="", sufix="mg/L", model_in="inputs.bod_in", model_out="inputs.bod_out")
        <!--InputInOut(label="COD", id_custom="cod", type="number" , description="", sufix="mg/L", model_in="input.cod_in", model_out="input.cod_out")-->
        <!--InputInOut(label="TN", id_custom="tn", type="number" , description="", sufix="mg/L", model_in="inputs.tn_in", model_out="inputs.tn_out")-->
        <!--InputInOut(label="NO3", id_custom="no3", type="number" , description="", sufix="mg/L", model_in="input.no3_in", model_out="input.no3_out")-->
        <!--InputInOut(label="NH4", id_custom="nh4", type="number" , description="", sufix="mg/L", model_in="input.nh4_in", model_out="input.nh4_out")-->
        <!--InputInOut(label="TP", id_custom="tp", type="number" , description="", sufix="mg/L", model_in="input.tp_in", model_out="input.tp_out")-->
        <!--InputInOut(label="PO43", id_custom="po43", type="number" , description="", sufix="mg/L", model_in="input.po43_in", model_out="input.po43_out")-->
        <!--InputInOut(label="ECOLI", id_custom="ecoli", type="number" , description="", sufix="mg/L", model_in="input.ecoli_in", model_out="input.ecoli_out")-->
        <!--InputInOut(label="HEGGS", id_custom="heggs", type="number" , description="", sufix="mg/L", model_in="input.heggs_in", model_out="input.heggs_out")-->


      b-col(cols=9)
        b-row.font-weight-bold
          b-col Type
          b-col Linear
          b-col Square
          b-col Exponential
          b-col Results
        rowResult(label="BOD", :groupData="lev_0_bod", :results="calcFormula('bod',lev_0_bod)")
        rowResult(label="TN", :groupData="lev_0_tn", :results="calcFormula('tn',lev_0_tn)")
        rowResult(label="COD", :groupData="lev_0_cod", :results="calcFormula('cod',lev_0_cod)")
        rowResult(label="NO3", :groupData="lev_0_no3", :results="calcFormula('no3',lev_0_no3)")
        rowResult(label="NH4", :groupData="lev_0_nh4", :results="calcFormula('nh4',lev_0_nh4)")
        rowResult(label="TP", :groupData="lev_0_tp", :results="calcFormula('tp',lev_0_tp)")
        rowResult(label="PO43", :groupData="lev_0_po43", :results="calcFormula('po43',lev_0_po43)")
        b-row
          b-col --------------------------------------------
        rowResult(label="HEGGS", :groupData="lev_0_heggs", :results="calcFormula('heggs',lev_0_heggs)")
        rowResult(label="ECOLI", :groupData="lev_0_ecoli", :results="calcFormula('ecoli',lev_0_ecoli)")

</template>

<script>
const axios = require('axios');
const ss = require('simple-statistics');
import rowResult from './helpers/rowResults'
import InputInOut from './Inputs/InputInOutResults'
import GeneralMenu from '@/components/GeneralMenu.vue'

const DEBUG_MODE = false;

Array.prototype.sum = function(){
  return this.reduce((p,c)=>(p+c),0);
};


export default {
  name: "ComputeResults",
  components:{rowResult, InputInOut, GeneralMenu},
  data(){
    return{
      inputs:{
        bod_in: "",
        bod_out: "",
        cod_in: "",
        cod_out: "",
        tn_in: "",
        tn_out: "",
        no3_in: "",
        no3_out: "",
        nh4_in: "",
        nh4_out: "",
        tp_in: "",
        tp_out: "",
        po43_in: "",
        po43_out: "",
        ecoli_in: "",
        ecoli_out: "",
        heggs_in: "",
        heggs_out: "",
      },
      case_tech_type: "",
      case_tech_subtype: "",
      type_options: [
        { value: "", text: 'Please select an option' },
        { value: "CW", text: 'Constructed wetlands' },
        { value: "GR", text: 'Green Roof' },
        { value: "GW", text: 'Green Wall' },
        { value: "HA", text: 'Hydroponics/Aquaponics' },
        { value: "I-SRS", text: 'In-stream retention systems ' },
        { value: "NW", text: 'Natural Wetlands' },
        { value: "PL", text: 'Ponds/Lagoons' },
        { value: "MS", text: 'Multi Stage' },
        { value: "SIS", text: 'Soil infiltration systems' },
        { value: "WS", text: 'Willow systems' }
      ],
      dataAll:[],
      inflow:1000,
      inflow_cont:{},
      outflow_cont:{}
    }
  },
  mounted(){
    this.getData();
  },
  methods:{
    cleanData(){
      this.dataAll[0].doc_data = JSON.parse(this.dataAll[0].doc_data);
      console.log(this.dataAll[0]);
      for( let p in this.dataAll){
        console.log(p.doc_data, this.dataAll[p], this.dataAll)
        //this.dataAll[p].doc_data = JSON.parse(this.dataAll[p].doc_data);
      }
      //this.dataAll = this.dataAll.every((p=> {p.doc_data = JSON.parse(p.doc_data)}))
      this.dataAll = this.dataAll.filter(p=> {return p.surface > 0 && p.inflow > 0});
    },
    getData(){
      let _this = this;
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      //axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

      axios.get('https://snappAPI.icradev.cat/')
          .then(function (response) {
            // handle success
            _this.dataAll = JSON.parse(response.data.result);

            console.log("raw array:", _this.dataAll);
            _this.cleanData();
            console.log("raw array cleaned:", _this.dataAll);
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
    },
    calcLinear(id) {
      //console.log(this.filteredTable(id,"lineal"))
      let arrayXY = this.filteredTable(id,"lineal").array.filter(p =>{return (p[id+"_out"] != null) && (p[id+"_in"] != null)});
      arrayXY = arrayXY.map(p => {return {"code_cs": p.code_cs, "x": p.surface, "y": (p[id + "_in"] * p.inflow) - (p[id + "_out"] * p.inflow)}});
      let arrayXYFiltered = arrayXY.filter(p => {return p.y > 0});
      if (arrayXYFiltered.count === 0) error = "No enought data";
      if(true) {

        if (DEBUG_MODE) console.log(arrayXYFiltered);
        let linearRegression = this.compute_linear_regression(arrayXYFiltered);
        if (DEBUG_MODE) console.log("Lineal " + id + ": ", linearRegression);
        return {
          m: linearRegression.m.value,
          n: linearRegression.n.value,
          r_2: linearRegression.r_2.value,
          error: linearRegression.error,
          number: linearRegression.number,
          level: this.filteredTable(id,"lineal").level};
      }
      else{
        arrayXYFiltered = arrayXYFiltered.map(p => {return [p.x,p.y]});
        let res = ss.linearRegression(arrayXYFiltered);
        let lfunction = ss.linearRegressionLine(res);


        //console.log(res);
        return {m:res.m, n:res.b, r_2:ss.rSquared(arrayXYFiltered,lfunction)};
      }

    },
    calcSquare(id) {
      let arrayXY = this.filteredTable(id,"square").array.filter(p =>{return p[id+"_out"] != null && p[id+"_in"] != null});
      arrayXY = arrayXY.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p[id+"_in"]*p.inflow)-(p[id+"_out"]*p.inflow)}});
      let arrayXYSquared = arrayXY.filter(p=>{return (p.y > 0)});
      if(arrayXYSquared.count === 0) error = "No enought data";
      arrayXYSquared = arrayXYSquared.map(p=>{return {"code":p.code_cs, "x":Math.log(p.x), "y": Math.log(p.y)}});
      if(DEBUG_MODE) console.log(arrayXYSquared);
      let squarePRegression = this.compute_linear_regression(arrayXYSquared);
      if(DEBUG_MODE) console.log(squarePRegression);
      squarePRegression = {
        m: squarePRegression.m.value,
        n:Math.exp(squarePRegression.n.value),
        r_2:squarePRegression.r_2.value,
        error: squarePRegression.error,
        number: squarePRegression.number,
        level: this.filteredTable(id,"square").level
      };
      if(DEBUG_MODE) console.log("Squared: ",squarePRegression);
      return squarePRegression;
    },
    calcExponential(id){

      let arrayXY = this.filteredTable(id,"exp").array.filter(p =>{return (p[id+"_out"] != null) && (p[id+"_in"] != null)});
      arrayXY = arrayXY.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p[id+"_out"]*p.inflow)/(p[id+"_in"]*p.inflow)}});
      arrayXY = arrayXY.filter(p=>{return p.x > 0}); //discard 0 on surface
      let arrayXYExponential = arrayXY.filter(p=>{return (p.y > 0)});
      if(DEBUG_MODE) console.log(arrayXYExponential);
      arrayXYExponential = arrayXYExponential.map(p=>{return {"code":p.code_cs, "x":p.x, "y": Math.log(p.y)}});
      if(DEBUG_MODE) console.log(arrayXYExponential);
      let exponentialPRegression = this.compute_linear_regression(arrayXYExponential);
      if(DEBUG_MODE) console.log(exponentialPRegression);
      exponentialPRegression = {
        m: exponentialPRegression.m.value,
        n:Math.exp(exponentialPRegression.n.value),
        r_2:exponentialPRegression.r_2.value,
        error: exponentialPRegression.error,
        number: exponentialPRegression.number,
        level: this.filteredTable(id,"exp").level
      };
      if(DEBUG_MODE) console.log("Exponential: ",exponentialPRegression);
      return exponentialPRegression;
    },
    downloadAndCalc() {

      let _this = this;
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      //axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

      axios.get('http://localhost:3000/')
          .then(function (response) {
            // handle success
            let arrayRes = JSON.parse(response.data.result);
            console.log("raw array:",arrayRes);
            let arrayXY = arrayRes.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p.bod_in*p.inflow)-(p.bod_out*p.inflow)}});

            arrayXY = arrayXY.filter(p=>{return p.x > 0}); //discard 0 on surface
            console.log(arrayXY);

            //Linear
            let arrayXYFiltered = arrayXY.filter(p=>{return true});
            console.log(arrayXYFiltered);
            console.log("Lineal: ",_this.compute_linear_regression(arrayXYFiltered));

            //Squared
            let arrayXYSquared = arrayXY.filter(p=>{return (p.y > 0)});
            arrayXYSquared = arrayXYSquared.map(p=>{return {"code":p.code_cs, "x":Math.log(p.x), "y": Math.log(p.y)}});
            console.log(arrayXYSquared);
            let squarePRegression = _this.compute_linear_regression(arrayXYSquared);
            console.log(squarePRegression);
            squarePRegression = {m: squarePRegression.m.value, n:Math.exp(squarePRegression.n.value), r_2:squarePRegression.r_2.value};
            console.log("Squared: ",squarePRegression);

            //exponential
            arrayXY = arrayRes.map(p=>{ return {"code_cs":p.code_cs ,"x":p.surface, "y":(p.bod_out*p.inflow)/(p.bod_in*p.inflow)}});
            arrayXY = arrayXY.filter(p=>{return p.x > 0}); //discard 0 on surface
            let arrayXYExponential = arrayXY.filter(p=>{return (p.y > 0)});
            arrayXYExponential = arrayXYExponential.map(p=>{return {"code":p.code_cs, "x":p.x, "y": Math.log(p.y)}});
            console.log(arrayXYExponential);
            let exponentialPRegression = _this.compute_linear_regression(arrayXYExponential);
            console.log(exponentialPRegression);
            exponentialPRegression = {
              m: exponentialPRegression.m.value,
              n:Math.exp(exponentialPRegression.n.value), r_2:exponentialPRegression.r_2.value};
            console.log("Exponential: ",exponentialPRegression);
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },
    compute_linear_regression(arrayXY){
      let error = [];
      if(arrayXY.length  === 0) error.push({id: "array_zero", text: "La taula d'entrada esta buida"});
      let xi    = arrayXY.map(p=>Number(p.x));              //x points
      let yi    = arrayXY.map(p=>Number(p.y));              //y points
      let xi_sq = xi.map(p=>Math.pow(p,2));                 //x squared points
      let yi_sq = yi.map(p=>Math.pow(p,2));                 //y squared points
      let xiyi  = arrayXY.map(p=>{                          //x·y points
        return (p.x*p.y);
      });
      let N = arrayXY.length;                               //number of points

      if(DEBUG_MODE) console.log(xiyi);

      let xi_sum    = xi.sum();
      let yi_sum    = yi.sum();
      let xi_sq_sum = xi_sq.sum();
      let yi_sq_sum = yi_sq.sum();
      let xiyi_sum  = xiyi.sum();

      if(DEBUG_MODE) console.log(xi_sum);
      if(DEBUG_MODE) console.log(yi_sum);
      if(DEBUG_MODE) console.log(xi_sq_sum);
      if(DEBUG_MODE) console.log(yi_sq_sum);
      if(DEBUG_MODE) console.log(xiyi_sum);

      //compute m and b (y = mx + n)
      if(N*(xiyi_sum) - yi_sum*xi_sum  === 0) error.push({id: "m_num_zero", text: "Numerador de la M = 0"});
      if((N*xi_sq_sum - Math.pow(xi_sum,2))  === 0) error.push({id: "m_den_zero", text: "Denominador de la M = 0"});

      let m = (N*(xiyi_sum) - yi_sum*xi_sum)/(N*xi_sq_sum - Math.pow(xi_sum,2));

      if(m.isNaN) error.push({id: "m_nan", text: "M és NaN"});

      let n = (yi_sum - m*xi_sum)/N;

      if(DEBUG_MODE) console.log("m",N,N*(xiyi_sum), (yi_sum*xi_sum),N*xi_sq_sum, Math.pow(xi_sum,2));

      //compute r (correlation)
      let r_2 = Math.pow(N*xiyi_sum - xi_sum*yi_sum, 2)/((N*xi_sq_sum - Math.pow(xi_sum,2))*(N*yi_sq_sum - Math.pow(yi_sum,2)));
      if(error.length > 0) error.push({id: "num_entrades", text: "entrades = "+N});

      return {
        m:{value:m},
        n:{value:n},
        r_2:{value:r_2},
        number: N,
        error
      };
    },
    filteredTable(id,type){
      let actualData = this.dataAll;
      let lev_1_actualData = [];
      let lev_2_actualData = [];
      let _this = this;
      actualData = this.dataAll.filter(nbs => {
        if(type = "lineal") {

          return ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
              ((nbs.surface > 0)) &&
              ((nbs[id + "_in"] * nbs.inflow) - (nbs[id + "_out"] * nbs.inflow)) > 0;
        }
        else if(type = "square") {
          return ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
              ((nbs.surface != null) && (nbs.surface > 0)) &&
              ((p[id+"_in"]*p.inflow)-(p[id+"_out"]*p.inflow)) > 0
        }
        else if(type = "exp") {
          return ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
              ((nbs.surface != null) && (nbs.surface > 0)) &&
              ((p[id+"_out"]*p.inflow)/(p[id+"_in"]*p.inflow)) > 0
        }
      });
      if(this.case_tech_type !== ""){
        lev_1_actualData = actualData.filter(nbs => {
          if(type = "lineal") {

            return nbs.type === _this.case_tech_type &&
                ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                ((nbs.surface != null) && (nbs.surface > 0)) &&
                ((nbs[id + "_in"] * nbs.inflow) - (nbs[id + "_out"] * nbs.inflow)) > 0
          }
          else if(type = "square") {
            return nbs.type === _this.case_tech_type &&
                ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                ((nbs.surface != null) && (nbs.surface > 0)) &&
                ((p[id+"_in"]*p.inflow)-(p[id+"_out"]*p.inflow)) > 0
          }
          else if(type = "exp") {
            return nbs.type === _this.case_tech_type &&
                ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                ((nbs.surface != null) && (nbs.surface > 0)) &&
                ((p[id+"_out"]*p.inflow)/(p[id+"_in"]*p.inflow)) > 0
          }
        });
        if(this.case_tech_subtype !== ""){
          lev_2_actualData = lev_1_actualData.filter(nbs => {
            if(type = "lineal") {
              return nbs.type === _this.case_tech_type &&
                  nbs.sub_type === _this.case_tech_subtype &&
                  ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                  ((nbs.surface != null) && (nbs.surface > 0)) &&
                  ((nbs[id + "_in"] * nbs.inflow) - (nbs[id + "_out"] * nbs.inflow)) > 0
            }
            else if(type = "square") {
              return nbs.type === _this.case_tech_type &&
                  nbs.sub_type === _this.case_tech_subtype &&
                  ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                  ((nbs.surface != null) && (nbs.surface > 0)) &&
                  ((p[id+"_in"]*p.inflow)-(p[id+"_out"]*p.inflow)) > 0
            }
            else if(type = "exp") {
              return nbs.type === _this.case_tech_type &&
                  nbs.sub_type === _this.case_tech_subtype &&
                  ((nbs[id+"_out"] != null) && (nbs[id+"_in"] != null)) &&
                  ((nbs.surface != null) && (nbs.surface > 0)) &&
                  ((p[id+"_out"]*p.inflow)/(p[id+"_in"]*p.inflow)) > 0
            }
          });
        }
      }
      // console.log("Data All",this.dataAll );
      // console.log("Show global data:",actualData.length, actualData);
      //console.log("Level 0", actualData.length, "Level 1", lev_1_actualData.length, "Level 2", lev_2_actualData.length);
      if(lev_2_actualData.length > 2) return {level: 2, array: lev_2_actualData};
      else if (lev_1_actualData.length > 2) return {level: 1, array: lev_1_actualData};

      return {level: 0, array: actualData};
    },
    calcFormula(id, functions){
      let c_in = 0;
      let c_out = 0;
      //if(id === "bod") {c_in = this.inputs[id+"_in"] * this.inflow;  c_out = this.inputs[id+"_out"] * this.inflow;}
      c_in = this.inputs[id+"_in"] * this.inflow;
      c_out = this.inputs[id+"_out"] * this.inflow;

      if(functions.linear.r_2 > functions.square.r_2 && functions.linear.r_2 > functions.exponential.r_2 ){
        return ((c_in-c_out) - functions.linear.n) / functions.linear.m
      }
      else if(functions.square.r_2 > functions.linear.r_2 && functions.square.r_2 > functions.exponential.r_2 ){
        //console.log(c_in-c_out, functions.square.n,  functions.square.m);
        return Math.pow(((c_in-c_out) / functions.square.n), (1/functions.square.m));
      }
      else if(functions.exponential.r_2 > functions.linear.r_2 && functions.exponential.r_2 > functions.square.r_2 ){
        //console.log(c_in-c_out, functions.exponential.n,  functions.exponential.m);
        return Math.log(((c_out) / (c_in/functions.exponential.n))) / functions.exponential.m;
      }
      return "none";
    }
  },
  computed:{
    showBOD: function(){return true},
    subType_options: function () {

      switch (this.case_tech_type) {
        case "MS":
          return [
            { value: "", text: 'Please select an option' },
            { value: "AP+FP_PL", text: 'Anaerobic pond followed by facultative pond ' },
            { value: "AP+FP+MP_PL", text: 'Anaerobic pond followed by facultative pond followed by maturation pond ' },
            { value: "FP+MP_PL", text: 'Facultative pond followed by maturation pond ' },
            { value: "VSSF+HSSF_CW", text: 'Vertical CW followed by horizontal CW' },
          ];
        case "CW":
          return [
            { value: "", text: 'Please select an option' },
            { value: "CSO_CW", text: 'CSO' },
            { value: "French_CW", text: 'French configuration' },
            { value: "VSSF_CW", text: 'Vertical' },
            { value: "HSSF_CW", text: 'Horizontal' },
            { value: "FWS_CW", text: 'Free water surface' },
            { value: "IRM_CW", text: 'Intensified reactive media' },
            { value: "IA_CW", text: 'Intensified aeration' },
            { value: "R_CW", text: 'Recirculation' },
            { value: "HSSF_CW+MP_PL", text: 'Horizontal CW followed by maturation pond'},
          ];
        case "GR":
          return [
            { value: "", text: 'Green Roof' },
          ];
        case "GW":
          return [
            { value: "", text: 'Green Wall' },
          ];
        case "HA":
          return [
            { value: "", text: 'Please select an option' },
            { value: "A_HA", text: 'Aquaponics' },
            { value: "H_HA", text: 'Hydroponics' },
          ];
        case "I-SRS":
          return [
            { value: "", text: 'In-stream retention systems ' },
          ];
        case "NW":
          return [
            { value: "", text: 'Natural Wetlands' },
          ];
        case "PL":
          return [
            { value: "", text: 'Please select an option' },
            { value: "IA_PL", text: 'Intensified aerated ' },
            { value: "AP_PL", text: 'Anaerobic' },
            { value: "FP_PL", text: 'Facultative' },
            { value: "MP_PL", text: 'Maturation' },
            { value: "FP_P/L+FWS_CW", text: 'Facultative pond followed by free water surface constructed wetland' },

          ];
        case "SIS":
          return [
            { value: "", text: 'Please select an option' },
            { value: "SIS_R", text: 'Rapid' },
            { value: "SIS_S", text: 'Slow' },
          ];
        case "WS":
          return [
            { value: "", text: 'Willow systems' },
          ];

        default:
          return [{ value: "", text: 'Select type first' }];
      }
    },

    lev_0_bod(){ return {linear: this.calcLinear("bod"), square: this.calcSquare("bod"), exponential: this.calcExponential("bod")}},
    lev_0_tn(){ return {linear: this.calcLinear("tn"), square: this.calcSquare("tn"), exponential: this.calcExponential("tn")}},
    lev_0_cod(){ return {linear: this.calcLinear("cod"), square: this.calcSquare("cod"), exponential: this.calcExponential("cod")}},
    lev_0_no3(){ return {linear: this.calcLinear("no3"), square: this.calcSquare("no3"), exponential: this.calcExponential("no3")}},
    lev_0_nh4(){ return {linear: this.calcLinear("nh4"), square: this.calcSquare("nh4"), exponential: this.calcExponential("nh4")}},
    lev_0_tp(){ return {linear: this.calcLinear("tp"), square: this.calcSquare("tp"), exponential: this.calcExponential("tp")}},
    lev_0_po43(){ return {linear: this.calcLinear("po43"), square: this.calcSquare("po43"), exponential: this.calcExponential("po43")}},
    lev_0_heggs(){ return {linear: this.calcLinear("heggs"), square: this.calcSquare("heggs"), exponential: this.calcExponential("heggs")}},
    lev_0_ecoli(){ return {linear: this.calcLinear("ecoli"), square: this.calcSquare("ecoli"), exponential: this.calcExponential("ecoli")}},
  }
}
</script>

<style scoped>

</style>